/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangePasswordModelDto } from '../../models/change-password-model-dto';
import { ResetPasswordDto } from '../../models/reset-password-dto';

export interface UserChangePassword$Params {
      body?: ChangePasswordModelDto
}

export function userChangePassword(http: HttpClient, rootUrl: string, params?: UserChangePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<ResetPasswordDto>> {
  const rb = new RequestBuilder(rootUrl, userChangePassword.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResetPasswordDto>;
    })
  );
}

userChangePassword.PATH = '/v1/User/ChangePassword';
